const payTypes = [
  { value: 'no', label: 'Mobile Pay only' },
  { value: 'optional', label: 'Collection & Mobile Pay' },
  { value: 'mandatory', label: 'Pay On Collection only (Rx)' }
];

export default payTypes;
